import React from 'react';
import {
  CandidateLabel,
  CandidateLabelPhone,
  CardCandidate,
  ContainerCvVideoTitle,
  TitleExistCv,
} from './candidates.style';
import Candidate from '@models/Candidate';
import { Box } from '@mui/material';

import { ReactComponent as Arrow } from '../../assets/icons/FrameArrow.svg';
import { capitalizeFirstLetter } from '@/utils';
import { useNavigate } from 'react-router-dom';
import Colors from '@/theme/constants/Colors';
import Paths from '@/routes/paths';
import useCandidate from '@authentication/hooks/useCandidate';
import AlertDialog from '@atoms/alertDialog';
import { setItem } from '@/lib/storageUtil';
import { LocalStorageKeys } from '@authentication/constants';

interface CandidatesProps {
  data: Candidate[] | null;
}
function Candidates({ data }: CandidatesProps) {
  const { setCandidate } = useCandidate();
  const navigate = useNavigate();
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);

  const handleClickOpenDialogAlert = (candidate: any) => {
    setSelectedCandidate(candidate);
    setOpenDialogAlert(true);
  };

  const handleCloseDialogAlert = () => {
    setOpenDialogAlert(false);
  };

  const handleNavigate = async (candidate: Candidate) => {
    const candidateId = candidate?.id;

    if (candidateId) {
      setItem(LocalStorageKeys.CANDIDATE_Id, candidate?.id);
    }
    setCandidate(candidate);

    return navigate(Paths.CvVideoRecordPage);
  };
  const [selectedCandidate, setSelectedCandidate] = React.useState<any>(null);

  return (
    <>
      <Box sx={{}}>
        {openDialogAlert && selectedCandidate && (
          <AlertDialog
            handleConfirm={() => handleNavigate(selectedCandidate)}
            openDialogAlert={openDialogAlert}
            handleCloseDialogAlert={handleCloseDialogAlert}
          />
        )}

        {data &&
          data.length > 0 &&
          data.map((candidate: any) => (
            <CardCandidate key={candidate.id}>
              <Box>
                <CandidateLabel>
                  {capitalizeFirstLetter(candidate.candidate.user.firstname)}{' '}
                  {capitalizeFirstLetter(candidate.candidate.user.lastname)}
                </CandidateLabel>
                <CandidateLabelPhone>
                  {candidate.candidate.mobile}
                </CandidateLabelPhone>
              </Box>
              <Box>
                {candidate.candidate.cvVideoUrl ? (
                  <>
                    <ContainerCvVideoTitle
                      onClick={() =>
                        handleClickOpenDialogAlert(candidate.candidate)
                      }
                    >
                      <TitleExistCv>CV vidéo déjà existant</TitleExistCv>
                    </ContainerCvVideoTitle>
                  </>
                ) : (
                  <Box onClick={() => handleNavigate(candidate.candidate)}>
                    <Arrow color={Colors.PRIMARY_MAIN} />
                  </Box>
                )}
              </Box>
            </CardCandidate>
          ))}
      </Box>
    </>
  );
}

export default Candidates;
